<ng-container *ngIf="indicatorsGroups$ | async as indicatorsGroups">

    <compass-select-indicators parentLabel="Categorías" childrenLabel="Indicadores"></compass-select-indicators>
    geoIndicatorsURL
    <ng-container *ngIf="bricks$ | async as bricks">
        <compass-list-indicators [bricks]="bricks"></compass-list-indicators>
        list-indicators
    </ng-container>
    ends
</ng-container>